import React from "react";
import { CommentGet } from "../../Models/Comment";
import { useAuth } from "../../Context/useAuth";
import { FaTrash } from "react-icons/fa";

type Props = {
  comment: CommentGet;
  onDelete: (id: number) => void;
};

const StockCommentListItem = ({ comment, onDelete }: Props) => {
  const { user } = useAuth();
  const isCommentOwner = user?.userName === comment.createdBy;

  const handleDeleteClick = () => {
    if (window.confirm("Are you sure you want to delete this comment?")) {
      onDelete(comment.id);
    }
  };

  return (
    <div className="ml-4 w-full border rounded-md bg-white shadow-sm px-3 py-2 mb-1.5">
      <div className="flex items-start gap-2">
        <div className="flex flex-col w-full">
          {/* Header */}
          <div className="flex items-center justify-between gap-2 text-sm">
            <div className="flex items-center gap-2">
              <span className="text-gray-400">•</span>
              <p className="text-gray-500">@{comment.createdBy}</p>
              <span className="text-gray-400">•</span>
              <p className="text-gray-400 text-xs whitespace-nowrap">
                {new Date(comment.createdOn).toLocaleString()}
              </p>
            </div>
            {isCommentOwner && (
              <button
                onClick={handleDeleteClick}
                className="text-red-500 hover:text-red-700 transition-colors"
                title="Delete comment"
              >
                <FaTrash size={14} />
              </button>
            )}
          </div>

          {/* Content */}
          <p className="mt-1 text-sm text-gray-600 leading-snug whitespace-pre-wrap break-words">
            {comment.content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StockCommentListItem;
